/**
 * Resolve the header logo URL from organization branding.
 * Null/empty branding keeps the default portal mark.
 */
export function resolveHeaderLogoSrc(logoUrl?: string | null): string {
  const trimmed = typeof logoUrl === "string" ? logoUrl.trim() : "";
  return trimmed.length > 0 ? trimmed : "/logo.svg";
}

export type HeaderLogoErrorAction = "fallback-default" | "text-mark";

/**
 * Decide how the header should recover from a broken logo image.
 * Branding logos degrade to the default mark once; further failures show text.
 */
export function nextHeaderLogoErrorAction(opts: {
  hasBrandingLogo: boolean;
  alreadyUsingDefault: boolean;
}): HeaderLogoErrorAction {
  if (opts.hasBrandingLogo && !opts.alreadyUsingDefault) {
    return "fallback-default";
  }
  return "text-mark";
}
